import CompanyService from "./company-service";
import ReservationService from "./reservation-service";
import { CustomHeadersService } from "zoox-infra";
import moment from "moment";

export default class AppLoadService {
  constructor() {
    this.companyService = new CompanyService();
    this.reservationService = new ReservationService();
  }

  /**
   * Retrieves and sets some configuration data before app creation
   * @return { Promise } Company data
   */
  init() {
    const self = this;
    let subdomain = window.location.host.split(".")[0];

    let url = new URL(window.location);
    let origin = new URLSearchParams(url.search).get("origin");

    if (
      subdomain.indexOf("localhost") > -1 ||
      subdomain.indexOf("portal2") > -1 ||
      /(192.168.4.)\w+/.test(window.location.hostname) ||
      /(192.168.1.)\w+/.test(window.location.hostname) ||
      /\w(.ngrok.io)+/.test(window.location.hostname)
    ) {
      subdomain = process.env.VUE_APP_SUBDOMAIN;
    }

    // show loading
    return new Promise((resolve, reject) => {
      CustomHeadersService.removeCustomHeadersKey("Authorization");
      self.companyService
        .getBySubdomain(subdomain)
        .then(company => {
          if (company && company.id) {
            const oldCompany = self.companyService.getLocalCompany();
            const reservation = self.reservationService.getLocalReservation();

            if (
              (reservation && reservation.checkoutDate != null) ||
              reservation.checkoutDate !== ""
            ) {
              const checkoutDate = moment(reservation.checkoutDate).unix();
              const today = moment().unix();

              if (today > checkoutDate) {
                let currentLang = localStorage.getItem("currentLang");
                localStorage.clear();
                localStorage.setItem("currentLang", currentLang);
                window.location.reload();
              }
            }

            if (
              (oldCompany && oldCompany.id !== company.id) ||
              company.clearStorage
            ) {
              let currentLang = localStorage.getItem("currentLang");
              localStorage.clear();
              localStorage.setItem("currentLang", currentLang);
            }

            self.companyService.setLocalCompany(company);
            self.companyService.setGroupOrCompany(company);

            self.companyService
              .getCustomizationSettings(subdomain)
              .then(settings => {
                CustomHeadersService.setCustomHeaders({
                  "X-App-Name": process.env.VUE_APP_NAME,
                  "X-App-Version": process.env.VUE_APP_VERSION,
                  "X-Origin-Link": origin
                });
                self.companyService.setLocalCustomizationSettings(settings);
                // hide loading
                resolve(company);
              });
          } else {
            reject(null);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
